import { imageColor } from '../constant/generalData';

const TRACK_VIEW = 'V1';
const TRACK_RESOLUTION = '2000';

export const buildRingImageUrl = (
  options: { [key: string]: any } | undefined,
  styleId: string | undefined,
  customisationAllowed: boolean,
  cacheParam: string | undefined
): string => {
  const {
    Ring_Style,
    Ring_Crown,
    Diamond_Shape,
    Center_Diamond_Size,
    Ring_Side,
    Color,
    Crown_Color,
    Side_Stones,
    Wedding_Band,
    Single_First_Metal_Band,
    Double_First_Metal_Band,
    Double_Second_Metal_Band,
  } = options || {};

  if (!styleId || !Ring_Crown || !Diamond_Shape || !Center_Diamond_Size || !Ring_Side || !Color) {
    return '';
  }

  const isBuildOwn = styleId.includes('RB');
  const headColor = customisationAllowed ? Crown_Color : Color;
  const firstBand = Single_First_Metal_Band || Double_First_Metal_Band;
  const bandSuffix = `${firstBand ? `-${firstBand.split('_')[1]}` : ''}${Double_Second_Metal_Band ? `-${Double_Second_Metal_Band.split('_')[1]}` : ''}`;
  const bandCode = Wedding_Band === 'Double' ? 'C1' : Wedding_Band === 'Single' ? 'C2' : 'C3';

  const style = isBuildOwn
    ? `${styleId}-${Ring_Style}${Ring_Crown}-${Diamond_Shape}-${Center_Diamond_Size}-${Ring_Side}`
    : `${styleId}-${Ring_Crown}-${Diamond_Shape}-${Center_Diamond_Size}-${Ring_Side}`;

  const uniqueName = isBuildOwn
    ? `${styleId}${Ring_Style}${Ring_Crown}${Diamond_Shape}${Center_Diamond_Size}${Ring_Side}${headColor}${Color}${firstBand ? firstBand.split('_')[1] : ''}${Double_Second_Metal_Band ? Double_Second_Metal_Band.split('_')[1] : ''}${bandCode}`
    : `${styleId}${Ring_Crown}${Diamond_Shape}${Center_Diamond_Size}${Ring_Side}`;

  return `${process.env.REACT_APP_IMAGE_KEY}/${style}/${headColor}-${Color}${bandSuffix}/${bandCode}/${TRACK_VIEW}/${TRACK_RESOLUTION}/${imageColor(TRACK_VIEW)}/hq/DIA-${Side_Stones}/${uniqueName}${TRACK_VIEW}${TRACK_RESOLUTION}.jpg?${cacheParam}`;
};
